import { progressColor } from './progressColor'
import styles from './ProgressBar.module.css'

export function ProgressBar({ value, size = 'md' }: { value: number; size?: 'sm' | 'md' }) {
  return (
    <div className={[styles.track, size === 'sm' ? styles.sm : ''].join(' ')}>
      <div className={styles.fill} style={{ width: `${value}%`, background: progressColor(value) }} />
    </div>
  )
}
